module.exports = __webpack_public_path__ + "static/cheffu-8ff845fe8c8949998ef75c6c63557c46.png";